import { useLocation } from 'react-router-dom';

export function PageTransition({ children }: Readonly<{ children: React.ReactNode }>) {
    const location = useLocation();

    return (
        <div key={location.pathname} className="page-transition-enter">
            {children}
        </div>
    );
}
